import { render, staticRenderFns } from "./step-layout.vue?vue&type=template&id=aa6a39e2&scoped=true&"
var script = {}
import style0 from "./step-layout.vue?vue&type=style&index=0&id=aa6a39e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6a39e2",
  null
  
)

export default component.exports